"use client";

import styled from "styled-components";

interface NotFoundProps {
  $heightContain?: boolean;
}

export const Box = styled.div<NotFoundProps>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 30px 0;
  height: 100vh;
  width: 100vw;
  > svg {
    width: 90px;
    height: 90px;
    stroke: var(--textLight);
    transition: 0.3s;
    margin: auto;
    margin-bottom: 10px;
    margin-top: 0;
  }
`;

export const Text = styled.p`
  font-family: "Inter Bold";
  font-size: 28px;
  color: var(--textLight);
`;

export const Description = styled.span`
  font-family: "Roboto Medium";
  font-size: 16px;
  color: var(--textLight);
  margin-bottom: 20px;
  display: block;
  text-align: center;
`;
